const getters = {
  userInfo: (state) => state.USER_INFO,
  menus: (state) => state.MENUS,
};

export default getters;
